import {
  addUserByAdminAPI,
  getAllSubadminsAdminAPI,
  getAllAssignedUsersForSubAdminAPI,
  searchUsersAdminAPI,
  giveUserAccessToAdminAPI,
} from "./api";

export function addUserByAdmin(data) {
  return new Promise((resolve, reject) => {
    addUserByAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function giveUserAccessToAdmin(data) {
  return new Promise((resolve, reject) => {
    giveUserAccessToAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function getAllSubadminsAdmin(data) {
  return new Promise((resolve, reject) => {
    getAllSubadminsAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function getAllAssignedUsersForSubAdmin(data) {
  return new Promise((resolve, reject) => {
    getAllAssignedUsersForSubAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function searchUsersAdmin(data) {
  return new Promise((resolve, reject) => {
    searchUsersAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}
